import { VideoPlayerSrc } from './../../../../../models/camera.model';
import { SensorCoreObject } from '@core_n/asp/SensorCoreObject';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
// external imports
import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { AppConfig } from '@core_n/app.config';

@Component({
  selector: "app-iframe-video-player",
  templateUrl: "./iframe-video-player.html",
  styleUrls: ["iframe-video-player.scss"],
})
export class IframeVideoPlayerComponent implements OnInit {
  iframeUrl: SafeResourceUrl;
  @Input() public sensor: SensorCoreObject;
  private videoSrc: VideoPlayerSrc = AppConfig.settings.videoAddress.videoPlayerInfo.src;
  private samplePlayerBaseUrl = 'assets/iframe-video/player.html';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(){
    this.loadVideo();
  }

  ngOnChanges(changes: SimpleChanges){
    if (changes["sensor"]){
      this.loadVideo()
    }
  }

  extractSampleFromName(sensorName: string) {
    console.log(`[iframe video]  sensor name: ${sensorName}`);

    let base = "demo";
    const fileType = ".mp4";
    for (let i = sensorName.length - 1; i >= 0; i--) {
      if (Number.isInteger(+sensorName[i])) {
        base += (+sensorName[i] % 2);
        break;
      }
    }
    const fileName = base + fileType;
    console.log(`[iframe video] sample name ${fileName}`);
    const iframeUrlSample = `${this.samplePlayerBaseUrl}?src=${fileName}`
    return iframeUrlSample;
  }

  onLoad() {
    console.log("[iframe-video] iframe loaded");
  }

  loadVideo(){
    const streamUrl = this.extractVideoSrc();
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(streamUrl);
  }
  
  extractVideoSrc() {
    switch(this.videoSrc){
      case 'url': 
        return this.sensor.videoLink;
      case 'sample': {
        return this.extractSampleFromName(this.sensor.streamName);
      }
    }
  }
}
